
document.addEventListener("DOMContentLoaded", () => {
  const els = document.querySelectorAll(".selector-wrapper");
  els.forEach(el => {
    setTimeout(() => {
      el.classList.add("visible-temp");
    }, 5000); // 5 segundos
  });
});
